import React from "react";
import { useTranslation } from "react-i18next";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Box, Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

// All four ticket filters (Queues / Connections / Users / Tags)
// used to wear four different accent colors (orange / green / green
// / purple) which clashed against the brand-green dark palette.
// Unified them all on the same neutral hairline + subtle brand-
// green hover so the row reads as one filter cluster, not four
// random pills. The filter label itself tells you what it filters.
const useStyles = makeStyles((theme) => {
	const isDark = theme.palette.type === "dark";
	return {
		selectButton: {
			backgroundColor: isDark ? "#131614" : "#fff",
			borderRadius: 10,
			transition: "border-color 0.18s ease, background-color 0.18s ease",
			"&:hover": {
				backgroundColor: isDark
					? "rgba(46, 227, 122, 0.06)"
					: "rgba(37, 211, 102, 0.06)",
			},
			"& .MuiSelect-outlined": {
				paddingTop: 8,
				paddingBottom: 8,
				paddingLeft: 14,
				paddingRight: 32,
				fontSize: 13,
				fontWeight: 600,
				color: isDark ? "#e4e4e7" : "#0f172a",
			},
			"& .MuiSelect-icon": {
				color: isDark ? "#a8acb3" : "#64748b",
			},
			"& .MuiOutlinedInput-notchedOutline": {
				borderWidth: 1,
				borderColor: isDark
					? "rgba(255, 255, 255, 0.07)"
					: "#eaeaea",
			},
			"&:hover .MuiOutlinedInput-notchedOutline": {
				borderColor: isDark
					? "rgba(46, 227, 122, 0.4)"
					: "#86efac",
			},
		},
	};
});
const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
}) => {
	const classes = useStyles();
	const { t, i18n } = useTranslation();
	
	// Debug: log the translation and current language
	console.log('TicketsQueueSelect - Current language:', i18n.language);
	console.log('TicketsQueueSelect - localStorage language:', localStorage.getItem('language'));
	console.log('TicketsQueueSelect placeholder:', t("ticketsQueueSelect.placeholder"));

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<Box>
		<FormControl fullWidth margin="dense">
				<Select
					className={classes.selectButton}
					multiple
					variant="outlined"
					displayEmpty
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => t("ticketsQueueSelect.placeholder")}
				>
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem dense key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										backgroundColor: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</Box>
	);
};

export default TicketsQueueSelect;